<template>
  <header class="bg-[#FCFAF7]/95 backdrop-blur-md border-b border-stone-200/60 fixed w-full z-50 transition-all duration-300 shadow-sm">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-20">
        <!-- Logo and Brand Name -->
        <div class="flex-shrink-0 flex items-center group">
          <router-link to="/" class="flex items-center gap-3">
            <div class="w-20 h-20 bg-white border border-stone-200 rounded-2xl flex items-center justify-center shadow-sm overflow-hidden transition-transform duration-500 group-hover:scale-105">
              <img alt="Delba Logo" class="h-20 w-20 object-contain" :src="logo" />
            </div>
            <div class="flex flex-col">
              <span class="text-md font-black tracking-tight text-[#1C3F24] leading-tight uppercase">DELBA MARKET</span>
              <span class="text-[10px] font-bold tracking-[0.2em] text-[#C29D53] uppercase leading-none">SUPPLIES</span>
            </div>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <nav class="hidden md:flex items-center space-x-2">
          <router-link
            v-for="link in navLinks"
            :key="link.path"
            :to="link.path"
            class="text-stone-600 hover:text-[#1C3F24] px-4 py-2 text-sm font-bold transition-all hover:bg-[#1C3F24]/5 rounded-xl"
            active-class="text-[#1C3F24] bg-[#1C3F24]/5"
          >
            {{ link.name }}
          </router-link>
          
          <router-link
            to="/ContactUs"
            class="ml-4 px-6 py-2.5 bg-[#1C3F24] text-white text-sm font-bold tracking-wide rounded-xl hover:bg-[#2A5233] transition-colors shadow-sm shadow-[#1C3F24]/10"
          >
            Inquire Now
          </router-link>
        </nav>

        <!-- Mobile Menu Button -->
        <div class="md:hidden flex items-center">
          <button
            @click="toggleMobileMenu"
            class="text-[#1C3F24] w-10 h-10 flex items-center justify-center transition-colors rounded-xl bg-stone-100 border border-stone-200"
          >
            <Menu v-if="!isMobileMenuOpen" class="h-5 w-5" />
            <X v-else class="h-5 w-5" />
          </button>
        </div>
      </div>

      <!-- Mobile Navigation Menu -->
      <transition 
        enter-active-class="transition duration-200 ease-out" 
        enter-from-class="transform opacity-0 scale-95" 
        enter-to-class="transform opacity-100 scale-100" 
        leave-active-class="transition duration-100 ease-in" 
        leave-from-class="transform opacity-100 scale-100" 
        leave-to-class="transform opacity-0 scale-95"
      >
        <div v-show="isMobileMenuOpen" class="md:hidden absolute top-20 left-0 w-full bg-[#FCFAF7] border-b border-stone-200/80 pb-8 px-6 shadow-lg">
          <div class="flex flex-col space-y-1 pt-4">
            <router-link
              v-for="link in navLinks"
              :key="link.path"
              :to="link.path"
              @click="isMobileMenuOpen = false"
              class="text-stone-700 hover:text-[#1C3F24] block px-4 py-3.5 text-md font-bold transition-colors border-b border-stone-100 last:border-none hover:bg-[#1C3F24]/5 rounded-xl"
              active-class="text-[#1C3F24] bg-[#1C3F24]/5"
            >
              {{ link.name }}
            </router-link>
            <router-link
              to="/ContactUs"
              @click="isMobileMenuOpen = false"
              class="mt-6 w-full py-3.5 bg-[#1C3F24] text-white text-center font-bold tracking-wide rounded-xl shadow-md shadow-[#1C3F24]/10 block"
            >
              Inquire Now
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup>
import logo from "@/assets/logo.png";
import { ref } from "vue";
import { Menu, X } from "lucide-vue-next";

const isMobileMenuOpen = ref(false);

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/About" },
  { name: "Products", path: "/Products" },
  { name: "Order", path: "/Order" },
];

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
</script>
